import React from 'react'
import { Edit, SimpleForm } from 'react-admin'
import AutocompleteReferenceInput from '../AutocompleteReferenceInput'
import RolesInput from '../RolesInput'

const UserFleetRolesEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <AutocompleteReferenceInput
        source='fleet_id'
        reference='fleet'
        optionText='name'
        label='Fleet'
      />
      <AutocompleteReferenceInput
        source='user_id'
        reference='user'
        optionText='username'
        label='Username'
      />
      <RolesInput />
    </SimpleForm>
  </Edit>
)

export default UserFleetRolesEdit
